const toTitleCase = (str: string) => {
  if (!str) {
    return '';
  }

  return str
    .replace(/[_\W]+/g, ' ') // Replaces underscores, dashes, and non-alphanumeric characters with a space.
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export default toTitleCase;
